// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const deps = [];

module.exports = angular
  .module('bench.data.date', deps)
  .filter('blDateFormat', require('./dateFormat'))
  .filter('blMonth', require('./month'))
  .filter('blDay', require('./day'))
  .filter('date2', require('./date2'))
  .filter('blDaysAgo', require('./daysAgo'));
